import React from 'react';
import styles from './index.module.less';
import { useTranslation } from 'react-i18next';

const Error404 = (props): JSX.Element => {
  const { t } = useTranslation();
  const goHome = () => {
    props.history.replace('/home');
  };

  return (
    <div className={styles.errorContainer}>
      <div className={styles.title}>404</div>
      <div>{t('error.notFound')}</div>
      <div className={styles.button} onClick={goHome}>
        {t('error.backHome')}
      </div>
    </div>
  );
};

export default Error404;
